export default [{
    path: '/',
    component: ()=> import("@/views/Home"),
    meta:{
        
    },
    children:[]
}]